export default "__VITE_ASSET__BOiwNeHz__"